import { Component, OnInit } from '@angular/core';
import { LoginUnawareComponent } from '../../../../login-unaware-component';
import { DiagnosticsServiceFactory } from '../../../../services/diagnostics-service-factory';
import { GraphClientService } from '../../../../services/graph-client-service';
import { DateHelperService } from '../../../../services/date-helper';

const MAX_NUMBER_OF_EVENTS = 18;

/**
 *
 * */
@Component({
  selector: 'campfire-events-panel',
  templateUrl: './events-panel.component.html',
  styleUrls: ['./events-panel.component.scss']
})
export class EventsPanelComponent extends LoginUnawareComponent implements OnInit {
  events: any[] = [];

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService,
    private dateHelper: DateHelperService) {

    super(diagnosticsFactory.create('EventsPanelComponent'));
  }

  ngOnInit() {
    const header = { 'Prefer': 'outlook.timezone="Eastern Standard Time"' };
    const currentDate = (new Date()).toISOString();
    this.graphClient.getDataWithParameters(
      'EventsComponent',
      header,
      [currentDate, MAX_NUMBER_OF_EVENTS]
    ).subscribe(
      data => {
        const dynamicData = data as any;
        const allEvents = dynamicData.value as any[];
        this.events = allEvents;
      }, error => {
        this.diagnostics.logError(`ERROR loading data. Details: ${JSON.stringify(error)}`);
      });
  }
}
